<footer>
  <div class="lfoot">
    <div class="lfd wb">
      Screening Implementation for Munsalik by LFD<br />
      Copyright © {{ copyRightYear }} LFD Private Limited. All Rights Reserved
    </div>
  </div>
</footer>
